import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/site";

// Logo lockup. Transparent PNG. Use variant="white" on dark backgrounds
// (nav over the hero video, footer) and "color" on light backgrounds.
export default function Logo({ variant = "color", className = "", onClick, testId = "brand-logo" }) {
  const src = variant === "white" ? BRAND.logoWhite : BRAND.logo;
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid={testId}
      aria-label="ETAP home"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src={src}
        alt="ETAP"
        width="256"
        height="72"
        className="h-[4.5rem] w-auto"
        loading="eager"
        decoding="async"
      />
    </Link>
  );
}
